import api from "services/axiosInstance";
import { ITrackSplit } from "types/musicData";

export const CreateSplitSheet = async (
  sheetdata: ITrackSplit[],
  songId: string
) => {
  try {
    // Multiply all percentages by 0.85
    const adjustedSheetData = sheetdata.map((split) => ({
      ...split,
      percentage: split.percentage * 0.85
    }));

    const body = { songId, entries: adjustedSheetData };
    const { data } = await api.post("/split-sheets", body);
    return data.data;
  } catch (e) {
    throw e;
  }
};
